import { render, staticRenderFns } from "./Echarts3.vue?vue&type=template&id=1447b412&scoped=true&"
import script from "./Echarts3.vue?vue&type=script&lang=js&"
export * from "./Echarts3.vue?vue&type=script&lang=js&"
import style0 from "./Echarts3.vue?vue&type=style&index=0&id=1447b412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1447b412",
  null
  
)

export default component.exports